module.exports = __webpack_public_path__ + "img/country_brown_ba_list.bbf8247b.jpg";